import { Divider, Radio, Select, Space } from "antd";
import React, { useEffect, useState } from "react";
import Beliefs from "../../../components/graphs/Surveys/Beliefs";
//import BeliefsTime from "../../graphs/Surveys/BeliefsTime";
import Exceptions from "../../../components/graphs/Surveys/Exceptions";
import GeneralFeelings from "../../../components/graphs/Surveys/GeneralFeelings";
import PoliticalBeliefs from "../../../components/graphs/Surveys/PoliticalBeliefs";
import SurveyGraphSection from "../../../components/reusable/SurveyGraphSection/SurveyGraphSection";
import "../Surveys.css";
import EMV from "../../../components/graphs/EMV";
import Latinobarometro from "../../../components/graphs/Latinobarometro";
import LAPOP from "../../../components/graphs/LAPOP";
import { COUNTRY_OPTIONS } from "../../../utils/constants/countryOptions";
import { useCurrentLanguage } from "../../../hooks/useCurrentLanguage";
import TEXT from "../../../utils/text/surveys.json";


const { Option } = Select;
const SURVEY_COUNTRY_OPTIONS = require("./../../../utils/opinions/surveyCountryOptions.json");

export default function Regional() {
  const { language } = useCurrentLanguage();

  const [selectedPoliticalSurvey, setSelectedPoliticalSurvey] = useState("emv");
  const [surveyGraphSettings, setSurveyGraphSettings] = useState({
    survey: "emv",
    countryOptions: SURVEY_COUNTRY_OPTIONS["emv"],
    selectedCountry: SURVEY_COUNTRY_OPTIONS["emv"][0],
  });

  const onRadioChange = (event) => {
    setSelectedPoliticalSurvey(event.target.value);
  };

  const onSurveyChange = (newSelectedSurvey) => {
    setSurveyGraphSettings({
      survey: newSelectedSurvey,
      countryOptions: SURVEY_COUNTRY_OPTIONS[newSelectedSurvey],
      selectedCountry: SURVEY_COUNTRY_OPTIONS[newSelectedSurvey][0],
    });
  };

  const onSelectedCountryChange = (newCountry) => {
    setSurveyGraphSettings({
      ...surveyGraphSettings,
      selectedCountry: newCountry,
    });
  };
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    window.dataLayer.push({
      event: 'pageview'
    });
  }, []);

  return (
        <>
          
          <div className="surveys-page-content">
            <div className="surveys-page-graphs">
              <SurveyGraphSection
                graphID="feelings-graph"
                title={TEXT["generalFeelings"]["title"][language]}
                description={TEXT["generalFeelings"]["description"][language]}
                source={TEXT["generalFeelings"]["source"][language]}
                note={TEXT["generalFeelings"]["note"][language]}
                graphComponent={<GeneralFeelings isHomePageGraph={false} />}
                language={language}
              />
              <Divider className="divider-full-screen" />
              <SurveyGraphSection
                graphID="beliefs-graph"
                title={TEXT["beliefs"]["title"][language]}
                description={TEXT["beliefs"]["description"][language]}
                textPlacement={"right"}
                source={TEXT["beliefs"]["source"][language]}
                graphComponent={<Beliefs />}
                language={language}
              />
              <Divider className="divider-full-screen" />
              <SurveyGraphSection
                graphID="political-graph"
                title={TEXT["politicalViews"]["title"][language]}
                description={TEXT["politicalViews"]["description"][language]}
                source={TEXT["politicalViews"]["source"][language]}
                language={language}
                configuration={
                  <Radio.Group
                    onChange={onRadioChange}
                    value={selectedPoliticalSurvey}
                  >
                    <Space direction="vertical">
                      <Radio value={"emv"}>{TEXT["emv"][language]}</Radio>
                      <Radio value={"latinobarometro"}>
                        {TEXT["latino"][language]}
                      </Radio>
                    </Space>
                  </Radio.Group>
                }
                graphComponent={
                  <PoliticalBeliefs survey={selectedPoliticalSurvey} />
                }
              />
              <Divider className="divider-full-screen" />

              <SurveyGraphSection
                graphID="exceptions-graph"
                title={TEXT["exceptions"]["title"][language]}
                description={TEXT["exceptions"]["description"][language]}
                source={TEXT["exceptions"]["source"][language]}
                language={language}
                graphComponent={<Exceptions />}
                textPlacement="right"
              />
              <Divider className="divider-full-screen" />

              {/* <SurveyGraphSection
                graphID="beliefs-graph"
                title={TEXT["beliefs_time"]["title"][language]}
                description={TEXT["beliefs_time"]["description"][language]}
                textPlacement={"right"}
                source={TEXT["beliefs_time"]["source"][language]}
                configuration={
                  <Select
                    defaultValue={0}
                    style={{ width: 300 }}
                    onChange={handleQuestionChange}
                  >
                    {questions[language ?? "es"].map((question, index) => (
                      <Option key={index} value={index}>
                        {question}
                      </Option>
                    ))}
                  </Select>
                }
                graphComponent={<BeliefsTime selectedQuestionIndex={selectedQuestionIndex}/>}
                language={language}
              />
              <Divider className="divider-full-screen" />
 */}
              <div className="survey-page-full-surveys">
                <div className="survey-page-selects">
                  <div className="survey-page-select">
                    <Select
                      value={surveyGraphSettings.survey}
                      onChange={onSurveyChange}
                      style={{
                        width: "100%",
                      }}
                    >
                      <Option value="emv">{TEXT["emv"][language]}</Option>
                      <Option value="latino">{TEXT["latino"][language]}</Option>
                      <Option value="lapop">{TEXT["lapop"][language]}</Option>
                    </Select>
                  </div>
                  <div className="survey-page-select">
                    <Select
                      value={surveyGraphSettings.selectedCountry}
                      onChange={onSelectedCountryChange}
                      style={{
                        width: "100%",
                      }}
                    >
                      {surveyGraphSettings.countryOptions.map((c, key) => {
                        return (
                          <Option key={key} value={c}>
                            {
                              COUNTRY_OPTIONS.find((co) => {
                                return co.code === c;
                              })[
                                language === "en"
                                  ? "country_text_en"
                                  : "country_text"
                              ]
                            }
                          </Option>
                        );
                      })}
                    </Select>
                  </div>
                </div>
                <div className="full-screen">
                  {surveyGraphSettings.survey === "emv" ? (
                    <EMV selectedCountry={surveyGraphSettings.selectedCountry} />
                  ) : surveyGraphSettings.survey === "latino" ? (
                    <Latinobarometro
                      selectedCountry={surveyGraphSettings.selectedCountry}
                    />
                  ) : (
                    <LAPOP selectedCountry={surveyGraphSettings.selectedCountry} />
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
  );
}
